import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

const state = {
  project: [],
  isModalVisible: false
}

const mutations = {
  SET_QUOTATION_FILE (state, payload) {
    state.project = payload.data
  },
  ADD_QUOTATION_FILE (state, payload) {
    state.project = payload
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  }
}

const actions = {
  async loadQuotationFiles ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`project/${payload.id}/quotation-files`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTATION_FILE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addQuotationFile ({ commit }, payload) {
    let formData = new FormData()
    formData.append('file', payload.file)
    formData.append('type', payload.newRecord.type)
    if (payload.newRecord.comments) {
      formData.append('comments', payload.newRecord.comments)
    }
    formData.append('project_id', payload.project_id)

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`/quotations/upload-quotation`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_QUOTATION_FILE', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotation_files', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async deleteQuotation ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`quotations-file/${payload.id}/delete`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTATION_FILE', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  }
}

const getters = {
  project: state => state.project,
  isModalVisible: state => state.isModalVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
